/**
 * @generated SignedSource<<dee188075aa976e1c009117785435baf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatbotPatternTable_chatbotGroup$data = {
  readonly slug: string;
  readonly chatbots: {
    readonly __id: string;
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly slug: string;
        readonly name: string;
        readonly weight: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"ChatbotPatternTableDataRow_chatbot">;
      } | null;
    } | null> | null;
  };
  readonly id: string;
  readonly " $fragmentType": "ChatbotPatternTable_chatbotGroup";
};
export type ChatbotPatternTable_chatbotGroup = ChatbotPatternTable_chatbotGroup$data;
export type ChatbotPatternTable_chatbotGroup$key = {
  readonly " $data"?: ChatbotPatternTable_chatbotGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatbotPatternTable_chatbotGroup">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "chatbots"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "analyzerInput"
    },
    {
      "defaultValue": 120,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "status"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "withArchived"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ChatbotPatternTable_Query.graphql'),
      "identifierField": "id"
    }
  },
  "name": "ChatbotPatternTable_chatbotGroup",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "chatbots",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASC",
            "field": "KIND"
          }
        },
        {
          "kind": "Variable",
          "name": "status",
          "variableName": "status"
        },
        {
          "kind": "Variable",
          "name": "withArchived",
          "variableName": "withArchived"
        }
      ],
      "concreteType": "ChatbotConnection",
      "kind": "LinkedField",
      "name": "__ChatbotPatternTable_chatbotGroup_chatbots_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatbotEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Chatbot",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weight",
                  "storageKey": null
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "input",
                      "variableName": "analyzerInput"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "ChatbotPatternTableDataRow_chatbot"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "type": "ChatbotGroup",
  "abstractKey": null
};
})();

(node as any).hash = "6decfca551355287eab58db8e12ddb5f";

export default node;
